import React, { useState } from 'react';
import { ClickAwayListener } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { Input } from 'components/form/Input';
import {
  DropdownWrapper,
  DropdownFilterStyled,
  CaretIcon,
  Menu,
  FilterWrapper,
  Options,
  OptionWrapper,
  OptionText,
} from './styledComponents';

const Dropdown = ({
  options = [],
  defaultText = '',
  selectedOptionId,
  onSelectOption,
  onRemoveOption,
  showFilter = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filterTerm, setFilterTerm] = useState('');

  const selectedOption = options.find(
    (option) => option.id === selectedOptionId
  );

  const filteredOptions = filterTerm
    ? options.filter((option) =>
        option.text.toLowerCase().includes(filterTerm.toLowerCase())
      )
    : options;

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <DropdownWrapper>
        <DropdownFilterStyled
          onClick={() => setIsOpen(!isOpen)}
          isOpen={isOpen}
        >
          <span>{selectedOption ? selectedOption.text : defaultText}</span>
          <CaretIcon />
        </DropdownFilterStyled>
        {isOpen ? (
          <Menu>
            {showFilter && (
              <FilterWrapper>
                <Input
                  onChange={(e) => setFilterTerm(e.target.value)}
                  value={filterTerm}
                />
              </FilterWrapper>
            )}
            <Options>
              {filteredOptions.map((option) => {
                return (
                  <OptionWrapper key={option.id}>
                    <OptionText
                      onClick={() => {
                        setIsOpen(false);
                        onSelectOption(option);
                      }}
                      selected={option.id === selectedOptionId}
                      removable={onRemoveOption}
                    >
                      {option.text}
                    </OptionText>
                    {onRemoveOption && (
                      <CloseIcon onClick={() => onRemoveOption(option.id)} />
                    )}
                  </OptionWrapper>
                );
              })}
            </Options>
          </Menu>
        ) : null}
      </DropdownWrapper>
    </ClickAwayListener>
  );
};

export { Dropdown };
